﻿<template>
	<div :class="{ 'not-icon': !wantIcon }">
		<InputTextbox
			v-model:saturn="maskedZip"
			:label="label"
			:nonFloatingLabel="nonFloatingLabel"
			:placeholder="maskPlaceholder"
			:readonly="readonly"
			:disabled="disabled"
			:invalid="invalid"
			:type="'type' in $props ? type : 'text'"
			:infoIconObj="infoIconObj"
			:pattern="pattern"
			:comparer="comparer"
			:multiline="multiline"
			:showIcon="showIcon"
			:minlength="Number(minlength)"
			:maxlength="Number(maxlength || 10)"
			:icon="iconStyle"
			:copy="copy"
			:get="get"
			:set="set"
			:cssClass="cssClass"
			:height="height"
			:width="width"
			@input="onInputHandler"
			@change="onChangeHandler"
			@blur="onBlurHandler"
			@focus="onFocusHandler"
		>
			<template
				v-if="util.hasKey($slots, 'validation')"
				#validation
			>
				<slot name="validation"></slot>
			</template>
			<template
				#action
				v-if="util.hasKey($slots, 'action')"
			>
				<slot name="action"></slot>
			</template>
		</InputTextbox>
	</div>
</template>

<script>
	import InputTextbox from '@core/components/InputTextbox.vue';
	import util from '@core/services/util';
	import vstore from '@core/services/vstore';

	export default {
		name: 'InputZip',
		props: [
			'saturn',
			'cdk',
			'label',
			'nonFloatingLabel',
			'placeholder',
			'invalid',
			'readonly',
			'disabled',
			'multiline',
			'cssClass',
			'copy',
			'comparer',
			'get',
			'set',
			'maxlength',
			'minlength',
			'type',
			'pattern',
			'showIcon',
			'icon',
			'infoIconObj',
			'width',
			'height',
		],
		emits: ['update:saturn', 'input', 'change', 'focus', 'blur'],
		data() {
			return {
				vstore: vstore.state,
				vm: {
					saturn: null,
					cdk: null,
				},
				errorHover: false,
				wantIcon: null,
				iconStyle: null,
				maskedZip: null,
				maskPlaceholder: 'ZIP',
				previousValue: null,
			};
		},
		computed: {
			util() {
				return util;
			},
		},
		mounted() {
			this.$watch(
				() => this.$props,
				function (newValue) {
					this.init();
				},
				{ deep: true, immediate: true },
			);
		},
		created() {
			this.init();
			this.wantIcon = typeof this.showIcon != 'undefined' ? this.showIcon : true;
			this.iconStyle = !util.isNull(this.icon) ? this.icon : 'fas fa-search';
		},
		methods: {
			onBlurHandler($e) {
				this.$emit('blur', $e);
			},
			onFocusHandler($e) {
				this.$emit('focus', $e);
			},
			onChangeHandler(val) {
				this.$emit('change', this.vm.saturn);
			},
			onInputHandler(val) {
				this.vm.saturn = this.maskValue(val);
				this.maskedZip = this.vm.saturn;

				if (!this.get) this.$emit('update:saturn', this.vm.saturn);

				this.$emit('input', this.vm.saturn);
			},
			maskValue(value) {
				if (!util.isNull(value)) {
					let output = '';
					for (let i = 0; i < value.length; i++) {
						if (!isNaN(parseInt(value[i])) || (value[i] == '-' && i == 5)) {
							if (i == 5) {
								if (value[i] == '-') {
									if (value[i + 1]) output += value[i];
								} else {
									output += '-' + value[i];
								}
							} else {
								output += value[i];
							}
						}
					}
					return output;
				}
			},
			isNull(val) {
				if (val === null) {
					return '';
				} else {
					return val;
				}
			},
			init() {
				this.vm.cdk = this.cdk;
				this.vm.saturn = this.set ? this.set(this.saturn) : this.saturn;
				this.maskedZip = this.maskValue(this.vm.saturn);
			},
		},
		components: {
			InputTextbox,
		},
	};
</script>
